import { createGlobalStyle } from 'styled-components'
import { theme } from 'utils/theme'
import bgImage from 'assets/svg/bg.svg'
import { BRAND } from 'constants/appConstants'

const GlobalStyle = createGlobalStyle`
  body {
    font-family: ${({ theme: { brand } }) => (brand === BRAND.ATH ? 'AzoSans' : 'Futura Std')};
    letter-spacing: ${({ theme: { brand } }) => brand === BRAND.GCAD && '0.03em'};
    font-weight: 500;
    margin: 0;
    background: ${({ theme: { brand } }) => (brand === BRAND.ATH ? theme.colors.background : theme.gradients.gcad)};
    background-image: ${({ theme: { brand } }) => brand === BRAND.ATH && `url(${bgImage})`};
    background-repeat: no-repeat;
    background-position: center;
    background-size: auto;
    color: ${theme.colors.white};
  }

  h1, h2, h3, h4, h5, h6, p {
    margin: 0 0 22px 0;
  }

  ul {
    list-style: none;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  img {
    width: 100%;
  }

  @-webkit-keyframes heartbeat {
    from {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: center center;
              transform-origin: center center;
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    10% {
      -webkit-transform: scale(0.91);
              transform: scale(0.91);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    17% {
      -webkit-transform: scale(0.98);
              transform: scale(0.98);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    33% {
      -webkit-transform: scale(0.87);
              transform: scale(0.87);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    45% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
  }

  @keyframes heartbeat {
    from {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-transform-origin: center center;
              transform-origin: center center;
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    10% {
      -webkit-transform: scale(0.91);
              transform: scale(0.91);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    17% {
      -webkit-transform: scale(0.98);
              transform: scale(0.98);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
    33% {
      -webkit-transform: scale(0.87);
              transform: scale(0.87);
      -webkit-animation-timing-function: ease-in;
              animation-timing-function: ease-in;
    }
    45% {
      -webkit-transform: scale(1);
              transform: scale(1);
      -webkit-animation-timing-function: ease-out;
              animation-timing-function: ease-out;
    }
  }

  .heartbeat-animation {
    -webkit-animation: heartbeat 4s ease-in-out infinite both;
    animation: heartbeat 4s ease-in-out infinite both;
  }
`

export default GlobalStyle
